import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Box } from '@landtrustinc/design-system';

const InboxPageMobileLoading = () => {
  return (
    <Box display="flex" flexDirection="column" width="100%" background="white">
      {/* Hero image with overlay text */}
      <Box mb="28px">
        <Skeleton height={352} borderRadius={0} />
      </Box>

      <Box display="flex" flexDirection="column" gap="16px" mx="20px">
        <Box display="flex" gap="20px">
          {/* Tab links */}
          <Skeleton width={80} height={30} borderRadius={8} />
          <Skeleton width={60} height={30} borderRadius={8} />
        </Box>

        {/* Package title */}
        <Box display="flex" mt="16px">
          <Skeleton width={200} height={27} borderRadius={8} />
        </Box>

        {/* Trip Details heading */}
        <Box display="flex" mt="8px">
          <Skeleton width={100} height={22} borderRadius={8} />
        </Box>

        {/* Trip detail items */}
        <Box display="flex" flexDirection="column" gap="16px" mt="8px">
          {/* Guests */}
          <Box display="flex" alignItems="center" gap="12px">
            <Skeleton circle width={40} height={40} />
            <Skeleton width={80} height={18} borderRadius={8} />
          </Box>

          {/* Check-in */}
          <Box display="flex" alignItems="flex-start" gap="12px">
            <Skeleton circle width={40} height={40} />
            <Box display="flex" flexDirection="column" gap="4px">
              <Skeleton width={70} height={18} borderRadius={8} />
              <Skeleton width={180} height={14} borderRadius={8} />
              <Skeleton width={160} height={12} borderRadius={8} />
            </Box>
          </Box>

          {/* Hunting Days */}
          <Box display="flex" alignItems="flex-start" gap="12px">
            <Skeleton circle width={40} height={40} />
            <Box display="flex" flexDirection="column" gap="4px">
              <Skeleton width={100} height={18} borderRadius={8} />
              <Skeleton width={170} height={14} borderRadius={8} />
              <Skeleton width={190} height={12} borderRadius={8} />
            </Box>
          </Box>

          {/* Check-out */}
          <Box display="flex" alignItems="flex-start" gap="12px">
            <Skeleton circle width={40} height={40} />
            <Box display="flex" flexDirection="column" gap="4px">
              <Skeleton width={80} height={18} borderRadius={8} />
              <Skeleton width={150} height={14} borderRadius={8} />
              <Skeleton width={200} height={12} borderRadius={8} />
            </Box>
          </Box>
        </Box>

        {/* Price section */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          py="20px"
          mt="16px"
          borderTop="1px solid"
          borderColor="gray.200"
        >
          <Box display="flex" flexDirection="column" gap="4px">
            <Skeleton width={100} height={22} borderRadius={8} />
            <Skeleton width={70} height={14} borderRadius={8} />
          </Box>
          <Skeleton width={24} height={24} borderRadius={4} />
        </Box>
      </Box>
    </Box>
  );
};

export default InboxPageMobileLoading;
